/**
 * Created by Bob.Gear on 16/09/15.
 */
//------------------------------------------------------------------------
//  projectCreatedDateFilter Directive
//------------------------------------------------------------------------
angular.module("EICDataStream3.queryBuilder")
    .controller('projectCreatedDateFilterController', ['$scope' ,
      function ($scope) {
        $scope.componentName = "projectCreatedDateFilterForm";

        $scope.resetFilter = function () {
          $scope.clearCreateDate();
        };

        $scope.clearCreateDate = function () {
          delete $scope.criteria["createdWithinWeeks"];
        };

        $scope.removeProjectCreatedDateFilter = function () {
          $scope.resetFilter();
          $scope.$parent.removeFilter("#projectCreatedDateFilter");
        };

        $scope.showInvalidMessage = function(){
          var showMessage = false;

          if (!angular.isNumber($scope.criteria.createdWithinWeeks) && $scope.criteria.createdWithinWeeks != "")
            showMessage = true;

          if ($scope.projectCreatedDateFilterForm.$pristine)
            showMessage = false;

          $scope.projectCreatedDateFilterForm.$setValidity("$valid", !(showMessage || $scope.projectCreatedDateFilterForm.$pristine));

          return showMessage;
        };

        // default value
        if (!$scope.criteria.createdWithinWeeks) $scope.criteria.createdWithinWeeks = 4;

      }])
    .directive('projectCreatedDateFilter', ['$compile',
      function ($compile) {
        return {
          replace:     true,  // replace the placeholder element with the template
          restrict:    'A',   // usage: <div project-name-filter />
          templateUrl: "../app-ds3/search/queryBuilder/filters/projectCreatedDateFilter.tmpl.html",

          link: function ($scope, iElement, iAttrs) {
            var txtCreatedWithinWeeks = iElement.find('#txtCreatedWithinWeeks');
            txtCreatedWithinWeeks.attr('placeholder', txtCreatedWithinWeeks.attr('placeholder-text'));

            iElement.on('$destroy', function() {
              var i=0;
            });
          },

          controller: 'projectCreatedDateFilterController'
        };
      }]);
//------------------------------------------------------------------------

